import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api';
import { appointmentEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';
import type { UpdateCustomerNotesDto } from '@/types/jobAppointment';

interface Vars extends UpdateCustomerNotesDto {
  appointmentId: string;
}

/**
 * PATCH /appointments/:id/customer-notes — persist customer-facing notes.
 */
export function useUpdateCustomerNotes(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<unknown, Vars>({
    mutationFn: ({ appointmentId, ...body }) =>
      apiPatch(operationsClient, appointmentEndpoints.customerNotes(appointmentId), body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: jobKeys.appointments(jobId) });
      toast.success('Customer notes saved');
    },
  });
}
